import lozad from 'lozad';

export const observer = lozad('.lozad', {
  rootMargin: '100% 0px',
  threshold: 0.1,
  loaded: function(el) {
    el.classList.add( 'loaded' )
  }
});

observer.observe();

export const MediaObserver = lozad('.lozad-fwm', {
  rootMargin: '150% 0px',
  threshold: 0.1,
  loaded: function(el) {
    el.classList.add( 'loaded' )
  }
});

MediaObserver.observe();